import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=38303298&scoped=true&"
import script from "./GenericModal.vue?vue&type=script&lang=js&"
export * from "./GenericModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericModal.vue?vue&type=style&index=0&id=38303298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38303298",
  null
  
)

export default component.exports